import { BobRequest } from "../../model/bob-request";
import { Microservice } from "../../model/microservice";
import { BaseChainableComponent } from "../pipeline/base-chainable-component";
import { IProcessable } from "../pipeline/processable.interface";

export class BobRequestSerializingComponent extends BaseChainableComponent<BobRequest> implements IProcessable<BobRequest> {

	/**
	 * Start merging the requested page with the micro service content and assets.
	 *
	 * @param input
	 */

	public process(input: BobRequest): BobRequest {

		const microServices = input.microservices;
		if (!microServices) {

			console.warn("BobRequestSerializingComponent: No micro service available.");
			return input;
		}

		// Search for móicro service markers and insert them into the HTML
		const markers: any | null = this.findMarkers(input.html);
		if (markers) {

			input.setHtml(this.enrichRequestedPage(input.html, microServices, markers));
		}

		return input;
	}

	/**
	 * Get the page that replaced the markers with the right micro services.
	 *
	 * @param page
	 * @param microServices
	 * @param markers
	 */

	private enrichRequestedPage(page: string, microServices: Microservice[], markers: any): string {

		let newPage = page;

		microServices.forEach((microService: Microservice, index: number) => {

			// If the response is empty just bail out.
			if (!microService.isLoaded) {

				return;
			}

			if (microService.html) {

				newPage = this.replacePageMarkers(newPage, markers[index], microService);
			}

			if (microService.css) {

				newPage = this.addCSStoHead(newPage, microService);
			}

			if (microService.js) {

				newPage = this.addJStoFooter(newPage, microService);
			}
		});

		return newPage;
	}

	/**
	 * Replace the markers on the page.
	 *
	 * @param page
	 * @param marker
	 * @param microService
	 */

	private replacePageMarkers(page: string, marker: any, microService: Microservice): string {

		return page.replace(marker, microService.html);
	}

	/**
	 * Find markers in the requested page response.
	 */

	private findMarkers(page: string): RegExpMatchArray | null {

		return page.match(/<div data-bob*([\s\S]*?(-url)?)<\/div>/g);
	}

	/**
	 * Add CSS assets from into the footer of the requested page.
	 *
	 * @param page
	 * @param result
	 */

	private addCSStoHead(page: string, result: Microservice): string {

		const headEnd = page.indexOf("</head>");
		let newHTML = page;

		result.css.forEach(asset => {

			newHTML = [
				page.slice(0, headEnd),
				`<link rel="stylesheet" href="${asset}">`,
				page.slice(headEnd)
			].join("");
		});

		return newHTML;
	}

	/**
	 * Add JavaScript assets from into the footer of the requested page.
	 *
	 * @param page
	 * @param result
	 */

	private addJStoFooter(page: string, result: Microservice): string {

		const bodyEnd = page.lastIndexOf("</body>");
		let newHTML = page;

		result.js.forEach(asset => {

			newHTML = [
				page.slice(0, bodyEnd),
				`<script type="text/javascript" src="${asset}"></script>`,
				page.slice(bodyEnd)
			].join("");
		});

		return newHTML;
	}
}
